<template>

    <v-tooltip bottom color="primary">
        <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
                <div ref="icon">
                    <v-icon :color="socketIconColor" style="opacity: 0.7" class="pa-0 ma-0">mdi-access-point</v-icon>
                </div>
            </v-btn>
        </template>

        <span v-show="socketConnection">Real-time communications link is active</span>
        <span v-show="!socketConnection">Real-time communications link is down</span>
    </v-tooltip>

</template>

<script>

    import Echo from 'laravel-echo/dist/echo';
    import {TimelineLite} from "gsap";

    export default {

        data() {
            return {
                animation: null,
            }
        },

        computed: {
            socketIconColor() {
                return typeof Echo !== 'undefined' ? 'green' : 'red';
            },
            socketConnection() {
                return typeof Echo !== 'undefined';
            }
        },

        mounted() {
            this.animation = new TimelineLite();
            this.runSocketIndicator();
        },

        methods: {

            runSocketIndicator() {

                setInterval(() => {
                    if (this.$refs.icon) {
                        this.animation.to(this.$refs.icon, 1, {
                            css: {opacity: 0.4, color: 'green'},
                        }).to(this.$refs.icon, 1, {
                            css: {opacity: 0.7}
                        });
                    }

                }, 1000);
            },
        }
    }
</script>
